<template>
    <div>
        <div class="flex between">
            <el-form :model="po" ref="poRef" label-width="80px" inline>
                <el-form-item prop="pid" label="分类">
                    <el-select v-model="po.pid" clearable>
                        <el-option v-for="item in po.configLists" :key="item.id" :label="item.cname" :value="item.id" />
                    </el-select>
                </el-form-item>
                <el-form-item label-width="15px">
                    <el-button @click="resetHandler">重置</el-button>
                    <el-button type="primary" @click="searchHandler">查询</el-button>
                </el-form-item>
            </el-form>
            <div class="table-opt">
                <el-button @click="addHandler">新增</el-button>
            </div>
        </div>
        <!-- 表格 -->
        <el-table :data="vo.tableList" style="width: 100%" v-loading="vo.loading">
            <el-table-column prop="id" label="ID"> </el-table-column>
            <el-table-column label="所属分类">
                <template #default="{ row }"> {{ getConfigName(row.pid) }} </template>
            </el-table-column>
            <el-table-column prop="c_title" label="手册名称"> </el-table-column>
            <el-table-column label="操作" min-width="50" class-name="deal-column">
                <template #default="{ row }">
                    <el-button text type="primary" @click="editClick(row)">编辑</el-button>
                    <el-button text type="primary" @click="deleteClick(row)"> 删除 </el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-style"></div>
        <FormDialog
            :visible="dialogVisible"
            @parentCallback="parentCallback"
            @closeDialog="handleCloseDialog"
            :articleId="po.targetArticleId"
            v-if="dialogVisible"
        />
    </div>
</template>
<script setup>
import { ElMessage, ElMessageBox } from 'element-plus';
import request from '@/request/index';
import { reactive, ref } from 'vue';
import FormDialog from './form/index.vue';
const po = reactive({
    pid: '',
    cid: '',
    pageSize: 10,
    pageNum: 1,
    targetArticleId: 0,
    childConfigLists: [],
    configLists: []
});
const vo = reactive({ tableList: [], loading: true, total: 0 });
const dialogVisible = ref(false);

// 根据应用查询角色级联信息
const queryInitHandler = async function () {
    vo.loading = true;
    const result = await request('queryQuotesConfigLists', { pid: po.pid });
    const list = result.data.list;
    if (result.data.totalCount === 0) {
        vo.tableList = [];
    } else {
        vo.tableList = list;
    }
    vo.total = result.data.totalCount;
    vo.loading = false;
};
queryInitHandler();

const queryConfigs = async function () {
    const result = await request('queryConfigLists', {
        pid: 0
    });
    po.configLists = result.data.list;
};
queryConfigs();

const getConfigName = (pid, cid) => {
    const parentMenu = po.configLists.find(item => item.id === pid);
    const childMenu = po.childConfigLists.find(item => item.id === cid);
    let displayLabel = parentMenu ? parentMenu.cname : '';
    const childLabel = childMenu ? childMenu.cname : '';
    if (childLabel) {
        displayLabel += ` - ` + childLabel;
    }
    return displayLabel;
};
const handleSizeChange = function (e) {
    po.pageSize = e;
    po.pageNum = 1;
    queryInitHandler();
};
const handleCurrentChange = function (e) {
    po.pageNum = e;
    queryInitHandler();
};
const poRef = ref(null);
const resetHandler = function () {
    poRef.value.resetFields();
    queryInitHandler();
};
const searchHandler = function () {
    po.pageNum = 1;
    queryInitHandler();
};
const openDialog = () => {
    dialogVisible.value = true;
};
const addHandler = () => {
    po.targetArticleId = 0;
    openDialog();
};
const handleCloseDialog = () => {
    dialogVisible.value = false;
};
const deleteClick = row => {
    ElMessageBox.confirm('确认要删除此配置吗', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
    })
        .then(async () => {
            const result = await request('deleteQuotesConfig', {
                id: row.id
            });
            if (result.status === 200) {
                ElMessage({
                    message: result.msg,
                    type: 'success'
                });
                queryInitHandler();
            }
        })
        .catch(() => {
            console.log('cancel');
        });
};
const editClick = article => {
    po.targetArticleId = article.id;
    openDialog();
};
const parentCallback = function () {
    handleCloseDialog();
    queryInitHandler();
};
</script>
